/**
 * useConfidoPaymentLinkMutation
 *
 * React Query mutation hook for POST /confido-payment-link.
 *
 * Usage:
 *   const { generatePaymentLink, isLoading } = useConfidoPaymentLinkMutation();
 *
 *   generatePaymentLink(
 *     { data, contactId, sk },
 *     { onSuccess: (res) => ..., onError: (err) => ... }
 *   );
 *
 * @param {Object}   [options]            - Optional useMutation overrides (onSuccess, onError, etc.)
 */

import { useMutation } from '@tanstack/react-query';
import { createConfidoPaymentLink } from 'services/accountServices';

export const useConfidoPaymentLinkMutation = (options = {}) => {
  const mutation = useMutation({
    mutationFn: ({ data, contactId, sk }) => createConfidoPaymentLink(data, contactId, sk),
    retry: false,
    ...options,
  });

  return {
    generatePaymentLink: mutation.mutate,
    generatePaymentLinkAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    reset: mutation.reset,
  };
};
